"use client";

import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import {AlertTriangle} from "lucide-react";
import { useTranslation } from "react-i18next";
import {LocalizationKeys} from "@/lib/all-localization-keys";

interface SignOutAllWarningDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
}

export function SignOutAllWarningDialog({
    open,
    onOpenChange,
    onConfirm,
}: SignOutAllWarningDialogProps) {
    const { t } = useTranslation();
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <div className="flex items-center gap-2">
                        <AlertTriangle className="h-5 w-5 text-destructive"/>
                        <AlertDialogTitle>{t(LocalizationKeys.DIALOG_SIGN_OUT_ALL_TITLE)}</AlertDialogTitle>
                    </div>
                    <AlertDialogDescription className="space-y-3 pt-2">
                        <p className="font-medium text-foreground">
                            {t(LocalizationKeys.DIALOG_SIGN_OUT_ALL_MESSAGE)}
                        </p>
                        <p>
                            {t(LocalizationKeys.DIALOG_SIGN_OUT_ALL_DETAIL)}
                        </p>
                        <p className="text-xs text-muted-foreground">
                            {t(LocalizationKeys.DIALOG_SIGN_OUT_ALL_HELP)}
                        </p>
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>{t(LocalizationKeys.BUTTON_CANCEL)}</AlertDialogCancel>
                    <AlertDialogAction onClick={onConfirm}>
                        {t(LocalizationKeys.DIALOG_SIGN_OUT_ALL_TITLE)}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
